import {useState, useEffect} from 'react';

const useRunOnceWhenTruthy = (callback, condition) => {
    const [isRun, setIsRun] = useState(false);
    useEffect(() => {
        if (condition && !isRun) {
            callback();
            setIsRun(true);
        }
    }, [isRun, setIsRun, callback, condition]);
};

export default useRunOnceWhenTruthy;
